import { BarChart3, FileCheck2, Layers3 } from "lucide-react";
import type { ReactNode } from "react";
import styles from "./auth.module.css";

export function AuthShell({ children }: { children: ReactNode }) {
  return (
    <main className={styles.layout}>
      <section className={styles.brand} aria-labelledby="auth-product-title">
        <div className={styles.lockup}>
          <img className={styles.mark} src="/ipf-logo.png" alt="" width="46" height="48" />
          <div>
            <strong>IPF</strong>
            <small>Yönetim Paneli</small>
          </div>
        </div>

        <div className={styles.brandCopy}>
          <span className={styles.kicker}>Kurumsal çalışma alanı</span>
          <h1 id="auth-product-title">Karardan yayına, tek çalışma düzeni.</h1>
          <p>İçerikleri, finansman yapılarını ve operasyon akışını güvenle yönetin.</p>
          <div className={styles.capabilities} aria-label="Panel kapsamı">
            <span><Layers3 size={17} /> İçerik ve hizmet yönetimi</span>
            <span><FileCheck2 size={17} /> İnceleme ve yayın akışı</span>
            <span><BarChart3 size={17} /> Operasyon ve performans görünümü</span>
          </div>
        </div>

        <footer>IPF Finance Investment Group · Yönetim Paneli</footer>
      </section>
      <section className={styles.main}>{children}</section>
    </main>
  );
}

export function AuthCard({
  eyebrow,
  title,
  description,
  children,
}: {
  eyebrow: string;
  title: string;
  description: string;
  children: ReactNode;
}) {
  return (
    <section className={styles.card}>
      <header className={styles.cardHeader}>
        <span>{eyebrow}</span>
        <h2>{title}</h2>
        <p>{description}</p>
      </header>
      {children}
    </section>
  );
}

export function AuthAlert({ children }: { children: ReactNode }) {
  return <div className={styles.alert} role="alert">{children}</div>;
}
